import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { TextInput } from '@opendate-app/setlist';

const axios = require('axios').default;

const FanSuggestInput = ({ team, value, onChange, onSelect, ...inputProps }) => {
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [hoverIndex, setHoverIndex] = useState(-1);
  const [searchTerm, setSearchTerm] = useState(null);

  useEffect(() => {
    const term = (searchTerm || "").trim();
    if (term.length < 2) { setResults([]); return undefined; }

    let ignore = false;
    const handle = setTimeout(() => {
      axios.get(`/teams/${team.id}/crm/fans/autocomplete`, { params: { name: term } })
        .then(({ data }) => {
          if (ignore) return;
          setResults(data || []);
          setActiveIndex(-1);
          setOpen(true);
        })
        .catch(() => {});
    }, 250);

    return () => { ignore = true; clearTimeout(handle); };
  }, [team.id, searchTerm]);

  const select = (fan) => {
    setOpen(false);
    setSearchTerm(null);
    onSelect(fan);
  };

  const handleKeyDown = (e) => {
    if (!open || results.length === 0) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setActiveIndex((i) => Math.min(i + 1, results.length - 1));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveIndex((i) => Math.max(i - 1, 0));
    } else if (e.key === "Enter" && activeIndex >= 0) {
      e.preventDefault();
      select(results[activeIndex]);
    } else if (e.key === "Escape") {
      e.preventDefault();
      setOpen(false);
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <TextInput {...inputProps}
                 value={value}
                 autoComplete="off"
                 aria-autocomplete="list"
                 aria-expanded={open && results.length > 0}
                 onKeyDown={handleKeyDown}
                 onBlur={() => {
                   setOpen(false);
                   setSearchTerm(null);
                 }}
                 onChange={(e) => {
                   setSearchTerm(e.target.value);
                   onChange(e);
                 }} />
      {open && results.length > 0 ? (
        <ul role="listbox"
            style={{
              position: "absolute",
              top: "100%",
              left: 0,
              right: 0,
              zIndex: 20,
              margin: "4px 0 0",
              padding: "4px 0",
              listStyle: "none",
              maxHeight: "240px",
              overflowY: "auto",
              background: "var(--sl-bg-primary)",
              border: "1px solid var(--sl-border-primary)",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)"
            }}>
          {results.map((fan, index) => (
            <li key={fan.id}
                role="option"
                aria-selected={index === activeIndex}
                onMouseDown={(e) => e.preventDefault()}
                onMouseEnter={() => setHoverIndex(index)}
                onMouseLeave={() => setHoverIndex(-1)}
                onClick={() => select(fan)}
                style={{
                  padding: "6px 12px",
                  cursor: "pointer",
                  background: (index === activeIndex || index === hoverIndex ? "var(--sl-bg-primary-hover)" : "transparent")
                }}>
              <div style={{ color: "var(--sl-text-primary)", fontSize: "14px" }}>{fan.name || fan.email}</div>
              {fan.email || fan.title_email_preview ? (
                <div style={{ color: "var(--sl-text-tertiary)", fontSize: "12px" }}>{fan.email || fan.title_email_preview}</div>
              ) : null}
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
};

FanSuggestInput.propTypes = {
  team: PropTypes.object.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired
};

export default FanSuggestInput;
